<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`New ${header} Result`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add analyte result'">
      <template #gated-content>
        <sample-result-form />
      </template>
    </permission-alert-gate>
  </div>
</template>
<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleResultForm from "@/components/lab/sample/form/SampleResultForm";
import { getModel } from "@/shared/fetch-utils";
export default {
  name: "SampleResultAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleResultForm,
  },
  data() {
    return {
      loading: true,
      sample_id: this.$route.params.sample_id || null,
      sample: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-box-open",
            title: "To Samples",
            linkto: "/samples/",
          },
          {
            icon: "fa-eye",
            title: "To Sample",
            variant: "info",
            linkto: `/samples/${this.sample_id}`,
          },
        ],
      };
    },
    header() {
      return this.sample && this.sample.identifier;
    },
  },
  methods: {},
  async created() {
    this.loading = true;

    this.sample = await getModel({
      model_type: "sample",
      id: this.sample_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
};
</script>
